/**
 * !!! DO NOT CHANGE ENUMERATION NAME WITHOUT PERMISSION !!!
 * !!! Description WILL BE REMOVED !!!
 */
export enum DocumentType {
  Unknown,
  CarrierCert = 1,
  Devann = 2,
  ArrivalNotice = 3,
  Memo,
  OO_CargoManifest,
  OI_CargoManifest,
  AO_CargoManifest,
  AI_CargoManifest,
  USDA = 9,
  LienNotice,
  ReleaseOrder = 11,
  POD = 12,
  CheckReq = 13,    // Bill
  Invoice,
  CRDB,

  Pickup = 18,
  
  IT = 20,
  
  AWB = 22,
  Profit = 23,
  Volume = 24,
  ExDec = 25,
  OOHBook = 26,
  
  CommPack = 28,
  MasterSet = 29,
  Check = 30,

  AgentStatement = 32,
  LocalStatement,
  
  OOHouseBL = 43,
  Correction = 44,
  AuthEntry = 45,
  Quotation = 46,
  BankDraft = 47,
  OriginCertificate = 48,
  OIHOutstanding = 49,
  OutofStateLogSheet = 50,
  ReleaseHistory = 51,
  
  Brokerage = 54,
  DockReceipt = 55,
  FreightAN = 56,
  ShippingAdvice = 57,
  
  DO = 59,
  TrailerLoad = 60,
  SecondAN = 61,
  GenFax,
  GenEmail,
  MasterArrivalNotice = 64,
  AgentPackage = 65,
  Label = 66,
  LabelComAddress = 67,
  LoadPlan = 68,
  
  EMPPerform = 70,
  MasterUSDA = 71,
  ETA = 72,
  DeferSummary = 73,
  
  Inland = 76,
  
  LabelFolder = 80,
  DeliveryOrderShort = 81,
  LabelAir = 82,
  
  C_ReleaseOrder = 87,
  OOHBookingReport = 88,
  MAuthEntry = 89,
  
  PreAlert = 92,
  AuditReport = 93,
  PickSlip = 94,
  AmsManifest = 96,
  InvenPick = 101,
  WarehouseReceipt = 102,
  AmsHistory = 103,
  Exdectransit = 106,
  DocumentPackage = 107,
  
  ShippingAdviceItaly = 114,
  AmsHistoryMaster = 118,
  AmsUsage = 120,
  AmsHistoryManifest = 121,
  ArrivalConfirmNotice = 122,
  CustomerNonActivity = 124,
  TelexRelease = 126,
  PrePickup = 127,
  
  CompanyProfile = 129,

  CheckSub = 131,
  ChkMessenger = 132,
  VesselAcct = 133,
  
  ANandROrder = 135,
  
  OILifting = 137,
  
  PuInvoice = 140,
  AMSOILifting = 141,
  DOShortLaser = 142,
  OEUSDA = 143,
  
  QuotationAir = 148,
  OOHBookAIFG = 149,
  ITLaser = 150,
  
  OIHouseBl = 154,
  PendingList = 155,
  
  TSASecurity = 158,
  Transfer = 159,
  
  CancelIT = 161,
  
  InvoiceS = 166,
  CheckS = 167,
  LabelPouch = 168,
  
  CrDbBatch = 172,
  PreliminaryClaim = 173,
  
  TSAUnknown = 175,
  
  MasterInvoice = 180,
  LabelBook = 181,
  ANMultiHouse = 182,
  
  InvenActivity = 186,
  InvenItemHistory = 187,
  
  WhseLabelReceive = 190,
  WhseLabelShip = 191,
  
  StraightBL = 196,
  CargoStatus = 197,

  WhseLabelOher = 200,
  ISFHistory = 201,
  ISFUsage = 202,
  
  ProfitSman = 206,
  
  VendorCostSummary = 208,
  VendorCostDetail = 209,
  EmptyCntrRtn = 210,
  ReturnGuarantee,
  AciHistory,
  IRC225 = 221,
  
  ExpenseSummary = 226,
  ExpenseDetail = 227,
  
  PeriodicGLSummary = 500,
  PeriodicGLDetail = 501,
  GeneralLedger,
  AcctBalanceByEntity = 503,
  GLAgingByEntry = 503,
  JournalBook,
  DailyAcctSummary,
  
  AgingAR = 506,
  NewARAging = AgingAR,
  AgingARDetail = 507,
  NewARAgingDetail = AgingARDetail,
  AgingAP = 508,
  NewAPAging = AgingAP,
  AgingAPDetail = 509,
  NewAPAgingDetail = AgingAPDetail,
  NewARAPAging = 750,
  NewARAPAgingDetail = 751,
  AgingAgentAR = 510,
  NewAgentARAging = AgingAgentAR,
  AgingAgentARDetail = 511,
  NewAgentARAgingDetail = AgingAgentARDetail,
  AgingAgentAP = 512,
  NewAgentAPAging = AgingAgentAP,
  AgingAgentAPDetail = 513,
  NewAgentAPAgingDetail = AgingAgentAPDetail,
  AgingAgent = 514,
  NewAgentAging = AgingAgent,
  AgingAgentDetail = 515,
  NewAgentAgingDetail = AgingAgentDetail,
  AgingCheckPayable = 516,
  NewCheckPayable = AgingCheckPayable,
  AgingCheckPayableDetail = 517,
  NewCheckPayableDetail = AgingCheckPayableDetail,
  AgingCheckReceivable = 518,
  NewCheckReceivable = AgingCheckReceivable,
  AgingCheckReceivableDetail = 519,
  NewCheckReceivableDetail = AgingCheckReceivableDetail,

  NewGeneralJournal = 520,
  NewTransactionQuery,

  BranchPerformanceDetail = 564,
  BranchPerformanceMonthly = 565,

  BranchPerformance = 566,
  PeriodicBankDetail,
  NewRecAging,
  NewRecAgingDetail,
  NewPayAging,
  NewPayAgingDetail,
  DutyBalance,
  DutyPendings,
  NewGLBalanceDetail,
  NewAgentBalanceDetail,
  IssueReady,
  DailyBankBalance,
  CustomerNonActivityHybrid,
  ArrivalNoticeL,
  NewCCPayableAgingSummary,

  DailyAccountActivitySub1,
  DailyAccountActivitySub2,
  DailyAccountActivitySub3,
  DailyAccountActivitySub3Detail,
  DailyAccountActivitySub4Detail,
  DailyAccountSub2,

  DutyBalanceDetail,
  DutyPendingsSub,
  DutyPendingsSubAP,
  VolumeSumByTEU,             // 590
  VolumeSumA,
  VolumeSumBySalesman,
  VolumeSumOther,
  VolumeO,  
  VolumeDetailA,
  VolumeDetailBySalesman,
  VolumeDetailOther,
  IssueReadyDraft,            // 598
  
  NewTrialBalance = 600,
  NewBalanceSheet = 601,
  NewIncomeStatement = 602,
  CashFlow = 603,
  NewTrialBalanceM = 604,
  NewBalanceSheetM = 605,
  NewIncomeStatementM = 606,
  IncomeStatementYC = 607,
  NewIncomeStatementDetail,
  NewIncomeStatementDetailM,
  NewIncomeStatementY,
  NewIncomeStatementYDetail,
  NewIncomeStatementYDetailM,
  NewIncomeStatementYM,

  IncomeStatementKR = 620,
  BalanceSheetKR = 621,
  TrialBalanceKR = 622,
  PaymentPrep = 623,
  AcctBalanceByEntity2 = 624,
  AcctGLSummary12 = 625,
 
  SalesCostByCustomer = 626,        //sjcho 20240619 - add Sales/Cost by Customer Report
  CustomerGrossProfit = 627,        //sjcho 20240619 - add B/L Gross Profit Report
  CustomerEstProfit = 628,          //sjcho 20240802 - add B/L Est. Profit Report
  NewProfitCustomerDetail = 629,    //sjcho 20240726

  GrossProfitYears = 630,         // <jhchoi date="2024-07-01" - add Gross Profit (5 Years) Report />
  TopSalesCustomer = 631,         // <jhchoi date="2024-07-02" - add Top 20 Sales Customer Report />
  TopSalesAgent = 632,            // <jhchoi date="2024-07-02" - add Top 20 Sales Agent Report />
  ProfitCargoTypeByYears = 633,   // <jhchoi date="2024-07-08" - add Profit by Cargo Type (5 Years) Report />
  VolumeCargoTypeByYears = 634,   // <jhchoi date="2024-07-09" - add Volume by Cargo Type (5 Years) Report />
  // SalesCostByCustomerDetail = 635,

  NewBankBalance = 700,
  OutStandingCheck = 701,
  NewProfitByOperation,
  NewProfitByCustomer,
  NewBankBalanceDetail,
  TentativeMargin,            //705
  GLAgingByEntryDetail = 706,
  PreviousBankTransaction,
  PreviousTransaction,
  FutureTransaction,
  AgentBalance,
  AgentBalanceDetail,
  BankReconHistory,
  NewCCPayable,            // mkpark 2019-07-05 Credit Card Payable Aging Report Ãß°¡
  NewCCPayableDetail,

  TruckerDO = 716,
  QuotationOT = 717,

  DeleteHistoryBillingsSummary = 720, // jhlee 2025-01-10 Delete History Billings Summary
  DeleteHistoryBLSummary = 721,  // jhlee 2025-01-14 Delete History BL Summary
  DeleteHistoryPaymentsSummary = 722,  // jhlee 2025-01-14 Delete History Payments Summary
  DeleteHistoryBillingsDetail = 723, // jhlee 2025-01-10 Delete History Detail
  DeleteHistoryPaymentsDetail = 724,  // jhlee 2025-01-14 Delete History Payments Detail

  PayrollSummary = 725,   // <jhchoi date="2025-01-23" - add Payroll Summary Report />

  EstProfitYears = 726, // jhlee 2025-02-19 Est. Profit (5 Years) Report 

  // Orchid Trans
  BTMasterDeliverySheet = 760,
  BTDeliveryInstruction,
  BTLoadInstruction,
  BTUnloadInstruction,
  BTManifestBrok,
  BTManifestCO,
  BTManifestShip,
  BTCargoReceipt,
  BTCntrStatusMemo,
  BTWorkSheet,
  BTFreightInvoice,
  BTDeliveryOrder,
  BTDeliveryOrderC,
  BTBillOfLading,
  BTBillOfLadingC,

  // Cloud Only
  LogEmail = 790,
  LogPrint,
  LogFax,
  LogCommunication,

}
